import { team } from '../../data/team.js';

export default function Equipo() {
  return (
    <div className="section" id="equipo">
      <div style={{ marginBottom: 52 }} data-stagger="80">
        <div className="section-label r">Quiénes somos</div>
        <h2 className="section-title r">El equipo</h2>
        <p className="section-sub r">
          Profesionales que no enseñan desde un libro. Enseñan desde la trinchera.
        </p>
      </div>
      <div className="team-grid" data-stagger="70">
        {team.map((m) => (
          <div className="team-card r" key={m.name}>
            <div className="team-photo">
              <img src={m.img} alt={m.name} loading="lazy" />
              <div className="team-photo-filter" />
            </div>
            <div className="team-info">
              <div className="team-name">{m.name}</div>
              <div className="team-role">{m.role}</div>
              <div className="team-bio">{m.bio}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
